import React from "react";
import { withTranslation } from 'react-i18next';

// I was considering moving the GET request for the data into here, but I don't know how it would effect the loading times
// (if this component is only loaded in after the other get request, then it would be slower)
const UserInfoDisplay = ({t,  userData, restricted }) => {

    return (
        <>
            <p>{t('UserData.Name')}: {userData.middle_name ? userData.first_name + " " + userData.middle_name + " " + userData.last_name : userData.first_name + " " + userData.last_name}</p>
            <p>{t('UserData.Username')}:  {userData.username}</p>
            {!restricted &&
           		<p>{t('UserData.DOB')}:  {userData.DOB}</p>
            }
            <p>{t('UserData.Email')}:  {userData.email}</p>
        </>
    )
}

export default withTranslation()(UserInfoDisplay);
//export default UserInfoDisplay